/* eslint-disable react/no-multi-comp */
import React from 'react';
import PropTypes from 'prop-types';

import SvgSymbol from 'common/components/svg-symbol';
import FormFieldConsumer from 'common/components/form/components/form-field-consumer';
import FormFieldProvider from 'common/components/form/components/form-field-provider';
import {connectToForm} from 'common/components/form/utils';
import './index.scss';

// Form
//
// Basic form, or remote form if url prop is passed.
//
// Wraps FormFieldProvider, so uses the same props.
//
// Usage:
// <Provider store={store}>
//   <Form
//     url={remoteUrlReturnsFormJson}
//   />
// </Provider>
const Form = (props) => {
  const {addFormSetChildForm, shouldHideFormSetForm, ...providerProps} = props;
  const {form, formId, url} = providerProps;
  return (
    <FormFieldProvider {...providerProps}>
      <div className={`Form ${form?.prefix || ''}`}>
        <span className={'Form-fields'}>
          {form?.ordered_fields?.map((name) => {
            return <FormFieldConsumer key={`${formId}-${name}`} name={name} />;
          })}
        </span>
        <span className={'Form-FormSet'}>
          {form?.formset && (
            <FormSet
              addFormAction={addFormSetChildForm}
              formId={formId}
              formset={form.formset}
              parentForm={form}
              shouldHide={shouldHideFormSetForm}
              url={url}
            />
          )}
        </span>
      </div>
    </FormFieldProvider>
  );
};

/*
 * FormSet is a private component used by Form
 * to encapsulate formset UI. In order to render
 * a formset, use the Form component instead with
 * the appropriate `form` payload structure for
 * formsets (see test fixtures), or a url that returns
 * that structure.
 */
export const FormSet = (props) => {
  const {addFormAction, formId, formset, parentForm, shouldHide, url} = props;
  const meta = formset?.meta;
  return (
    <div className={'FormSet'}>
      {formset?.forms.map((form) => {
        const hidden = shouldHide(form);
        return (
          <div
            className={`FormSet-form ${hidden ? 'FormSet-form--hidden' : ''}`}
            key={`${formId}-${form.prefix}`}>
            <Form
              form={form}
              formId={formId}
              parentForm={parentForm}
              url={url}
            />
          </div>
        );
      })}
      {meta?.canAdd && meta?.TOTAL_FORMS < meta?.MAX_NUM_FORMS && (
        <span className={'FormSet-addForm'} onClick={addFormAction}>
          <SvgSymbol name={'add'} />
          <span className={'FormSet-addForm-text'}>{meta?.addFormText}</span>
        </span>
      )}
    </div>
  );
};
FormSet.propTypes = {
  ...FormFieldProvider.propTypes,
  addFormAction: PropTypes.func,
  shouldHide: PropTypes.func,
};
FormSet.defaultProps = {
  addFormAction: () => null,
  shouldHide: () => false,
};

Form.propTypes = {
  ...FormFieldProvider.propTypes,
  ...FormSet.propTypes,
};

export default connectToForm(Form);
